import $api from "@/shared/http";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { CartFilterType, CartType } from "../../model/types";

export const fetchCartFilters = createAsyncThunk<
  {
    type: CartType;
    filters: { filters: CartFilterType };
  },
  { type: CartType; filters?: CartFilterType },
  { rejectValue: string }
>("cart/fetchCartFilters", async ({ type, filters }, { rejectWithValue }) => {
  try {
    const response = await $api.post(`/filters/basket/${type}`, {
      filters: filters || [],
    });

    if (response.status === 200) {
      return {
        type,
        filters: response.data,
      };
    } else {
      throw new Error("Server error");
    }
  } catch (error) {
    return rejectWithValue(error.message);
  }
});
